export const PermissionVoltage = {
    PUT: "mgr-voltage-**-PUT",
    POST: "mgr-voltage-POST",
    DELETE: "mgr-voltage-**-DELETE",
    GET: "mgr-voltage-GET",
    GET_UUID: "mgr-voltage-**-GET"
};